import * as Constants from './constants'

export const hopDongListRequest = (formData) => {
  return {
    type: Constants.HOPDONG_LIST_REQUESTING,
    payload: formData
  }
}

export const hopDongListSuccess = (data) => {
  return {
    type: Constants.HOPDONG_LIST_SUCCESS,
    data
  }
}

export const hopDongListError = (error) => {
  return {
    type: Constants.HOPDONG_LIST_ERROR,
    error
  }
}

export const hopDongDetailRequest = (formData) => {
  return {
    type: Constants.HOPDONG_DETAIL_REQUESTING,
    payload: formData
  }
}

export const hopDongDetailSuccess = (data) => {
  return {
    type: Constants.HOPDONG_DETAIL_SUCCESS,
    data
  }
}

export const hopDongDetailError = (error) => {
  return {
    type: Constants.HOPDONG_DETAIL_ERROR,
    error
  }
}

export const hopDongUpdateRequest = (formData, callback) => {
  return {
    type: Constants.HOPDONG_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const hopDongUpdateSuccess = (response) => {
  return {
    type: Constants.HOPDONG_UPDATE_SUCCESS,
    payload: response
  }
}

export const hopDongUpdateError = (error) => {
  return {
    type: Constants.HOPDONG_UPDATE_ERROR,
    error
  }
}

export const hopDongRemoveRequest = (formData, callback) => {
  return {
    type: Constants.HOPDONG_REMOVE_REQUESTING,
    payload: formData,
    callback
  }
}

export const hopDongRemoveSuccess = (response) => {
  return {
    type: Constants.HOPDONG_REMOVE_SUCCESS,
    payload: response
  }
}

export const hopDongRemoveError = (error) => {
  return {
    type: Constants.HOPDONG_REMOVE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/HopDong/actions.js